import React, { ReactNode } from 'react';

import { Surface } from '@infoods/lifebase-ui';
import classNames from 'classnames';

import classes from './MealGridContainer.module.scss';

type MealGridContainerProps = {
  children: ReactNode;
  className?: string;
};

const MealGridContainer = ({ children, className }: MealGridContainerProps) => {
  return (
    <Surface className={classNames(classes.mealTable, className)}>{children}</Surface>
  );
};

export { MealGridContainer };
